import { useState, useEffect } from "react";

import { usePostHog } from "posthog-js/react";

export type FeatureFlag =
  | "tips-box"
  | "switch-notations"
  | "computed-nodes"
  | "student-onboarding"
  | "computed-nodes-ref-on-click"
  | "team-billing"
  | "core-corca-libraries"
  | "school-picker-size";

export function useFeatureFlag<T extends string = FeatureFlag>(
  flagName: NoInfer<T>,
): boolean | string | undefined {
  const posthog = usePostHog();
  const [value, setValue] = useState(() => posthog.getFeatureFlag(flagName));

  useEffect(() => {
    return posthog.onFeatureFlags(() => {
      setValue(posthog.getFeatureFlag(flagName));
    });
  }, [posthog, flagName]);

  if (typeof window === "undefined" && process.env.NEXT_PUBLIC_FEATURE_FLAGS) {
    return process.env.NEXT_PUBLIC_FEATURE_FLAGS.split(",").includes(flagName);
  }

  return value;
}
